import axios, { AxiosInstance, AxiosResponse } from "axios";

export class NetworkProvider {
  private static axiosInstance: AxiosInstance;
  private static instance: NetworkProvider;
  private static responseBody = (response: AxiosResponse) => response.data;

  private constructor() {}
  public static getInstance(env?: string): NetworkProvider {
    if (!NetworkProvider.instance) {
      let baseUrl: string;
      switch (env.toLowerCase()) {
        case "staging":
          baseUrl = "https://staging.mudrex.com/api/auth-services/v1";
          break;
        case "uat":
          baseUrl = "https://uat.mudrex.com/api/auth-services/v1";
          break;
        case "sandbox":
          baseUrl = "https://sandbox.mudrex.com/api/auth-services/v1";
          break;
        case "production":
          baseUrl = "https://mudrex.com/api/auth-services/v1";
          break;
      }

      NetworkProvider.axiosInstance = axios.create({
        baseURL: baseUrl,
        timeout: 15000
      });
      NetworkProvider.instance = new NetworkProvider();
    }

    return NetworkProvider.instance;
  }

  public async get(url: string, config?: {}): Promise<any> {
    const response = NetworkProvider.axiosInstance
      .get(url, config)
      .then(NetworkProvider.responseBody)
      .catch(error => {
        if (error.response) {
          return error.response.data;
        }
      });
    return response;
  }

  public async post(url: string, body: {}, config?: {}): Promise<any> {
    const response = NetworkProvider.axiosInstance
      .post(url, body, config)
      .then(NetworkProvider.responseBody)
      .catch(error => {
        if (error.response) {
          return error.response.data;
        }
      });
    return response;
  }

  public async put(url: string, body: {}, config?: {}): Promise<any> {
    const response = NetworkProvider.axiosInstance
      .put(url, body, config)
      .then(NetworkProvider.responseBody)
      .catch(error => {
        if (error.response) {
          return error.response.data;
        }
      });
    return response;
  }

  public async delete(url: string, config?: {}): Promise<any> {
    const response = NetworkProvider.axiosInstance
      .delete(url, config)
      .then(NetworkProvider.responseBody)
      .catch(error => {
        if (error.response) {
          return error.response.data;
        }
      });
    return response;
  }
}
